import { supplierContactsListingRoutes } from './features/supplier-contacts-listing/supplier-contacts-listing.routes';
import { supplierContactRoutes } from './features/supplier-contact-details/supplier-contact-details.routes';

export const supplierContactsRoutes = [
  {
    path: '/supplier-contacts',
    name: 'supplier-contacts',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "supplier-contacts" */ './SupplierContacts'),
    children: [...supplierContactsListingRoutes, ...supplierContactRoutes]
  }
];
